import { AfterViewInit, Component, EventEmitter, OnDestroy, Output, ViewChild } from '@angular/core';
import { AuthService } from "../../../../features/auth/services/auth.service";
import { RouterLink, RouterLinkActive } from '@angular/router';

import { PaymentsComponent } from '../../../../features/policy/ui/payments/payments.component';
import { PaymentService } from '../../../../features/policy/services/payment.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-sidenav',
    imports: [RouterLink, RouterLinkActive, PaymentsComponent],
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements AfterViewInit, OnDestroy {
  @Output() closeMobileNav = new EventEmitter<void>();
  @ViewChild("payments") payments!: PaymentsComponent
  private openWithSub?: Subscription;
  menuItems: any[] = [
    {
      route: '/dashboard',
      icon: 'home',
      name: 'Inicio',
      allowedProfiles: []
    },
    {
      route: '/policies',
      icon: 'recent_actors',
      name: 'Pólizas',
      allowedProfiles: []
    },
    {
      route: '/claims',
      icon: 'car_crash',
      name: 'Reclamos',
      allowedProfiles: []
    },
    {
      route: '/cranes',
      icon: 'auto_towing',
      name: 'Asistencia vial',
      allowedProfiles: []
    },
    {
      route: '/claim-request',
      icon: 'payment_arrow_down',
      name: 'Reembolsos',
      subtitle:'Seguro Médico Internacional',
      allowedProfiles: []
    }
  ]

  constructor(private auth: AuthService, private paymentService: PaymentService) {}

  ngAfterViewInit() {
    this.openWithSub = this.paymentService.openWithPolicy$.subscribe((policy) => {
      this.payments.showWith(policy);
    });
  }

  ngOnDestroy() {
    this.openWithSub?.unsubscribe();
  }

  logOut(){
    this.auth.logOut()
  }
  showPayments() {
    this.payments.show()
  }
}
